module.exports = __webpack_public_path__ + "img/noun-damage-5458085.ed424451.svg";